// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { MiniTerminalBlocksProjectCreationService } from './mini-terminal-blocks-project-creation.service';

@Injectable({providedIn: 'root'})
export class MiniTerminalBlocksProjectCreationServiceDelegator {

  private _miniTerminalBlocksProjectCreationService: MiniTerminalBlocksProjectCreationService;

  set miniTerminalBlocksProjectCreationService(value: MiniTerminalBlocksProjectCreationService) {
    this._miniTerminalBlocksProjectCreationService = value;
  }

  public projectCreationFailureHandler() {
    this._miniTerminalBlocksProjectCreationService.projectCreationFailureHandler();
  }

  public async mountingRailAttached(): Promise<void> {
    return this._miniTerminalBlocksProjectCreationService.mountingRailAttached();
  }
}
